import React from "react";
import { Box, Skeleton } from "@mui/material";

const DropdownSkeleton = () => {
  return (
    <Box>
      <Skeleton
        variant="rounded"
        sx={{
          width: 150,
          height: 40,
          borderRadius: 2,
          display: "inline-block",
          bgcolor: "#E3E6F0",
          borderRadius: "16px",
          "& .MuiSkeleton-wave": {
            background: `linear-gradient(90deg, #E3E6F0 40%, #F9FBFF 60%, #E3E6F0 80%)`,
          },
        }}
        animation="wave"
      />
    </Box>
  );
};

export default DropdownSkeleton;
